import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackWonItemsLoggedInButtonClicked = () =>
    useTrackConversion({ goal: KameleoonGoalData.WonItemsLoggedInButtonClicked });
